export const VORWERK_PREFIX = 'vorwerk.digital/';
export const CRITICALITY_LABEL = VORWERK_PREFIX + 'criticality';
export const EXPOSURE_LABEL = VORWERK_PREFIX + 'exposure';
export const PERSONAL_DATA_LABEL = VORWERK_PREFIX + 'personal-data';
export const PRODUCT_LABEL = VORWERK_PREFIX + 'products';
